import React from 'react';
import { ChevronDown, FileSpreadsheet, Scale, BookOpen, Loader2 } from 'lucide-react';

const tabClass = (active) =>
  `flex items-center gap-2 px-5 py-3 text-sm font-semibold transition-colors whitespace-nowrap ${
    active
      ? 'text-[#24299d] dark:text-[#818cf8] shadow-[inset_0_-2px_0_0_#24299d] dark:shadow-[inset_0_-2px_0_0_#818cf8]'
      : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200'
  }`;

const MizanEmbeddedPreviewChrome = ({
  t,
  title,
  fileName,
  loading,
  expanded,
  onToggleExpanded,
  mizanTabValue,
  setMizanTabValue,
  exportButton,
  hasAgac,
  agacPending,
  hasYevmiye,
  hasGroupedMizan,
}) => (
  <div className={expanded ? 'space-y-4 mb-4' : 'mb-0'}>
    <div className="w-full flex items-center gap-2 md:gap-3">
      <button
        type="button"
        onClick={onToggleExpanded}
        className="flex-1 min-w-0 flex items-center gap-2 md:gap-3 text-left hover:opacity-80 transition-opacity"
      >
        <div className="flex items-center justify-center w-8 h-8 md:w-10 md:h-10 rounded-lg md:rounded-xl bg-blue-100 dark:bg-blue-900/30 shrink-0">
          <FileSpreadsheet size={18} className="text-blue-600 dark:text-blue-200 md:w-5 md:h-5" />
        </div>
        <div className="min-w-0 flex-1 text-left">
          <h3 className="text-sm md:text-lg font-semibold tracking-tight text-gray-900 dark:text-white">{title}</h3>
          {fileName ? (
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5 truncate" title={fileName}>
              {fileName}
            </p>
          ) : null}
        </div>
        <ChevronDown
          size={18}
          className={`text-gray-400 shrink-0 transition-transform duration-200 ${expanded ? 'rotate-180' : ''}`}
        />
      </button>
      {loading ? <Loader2 size={18} className="animate-spin text-[#24299d] shrink-0" /> : null}
      {expanded && exportButton ? <div className="shrink-0">{exportButton}</div> : null}
    </div>
    {expanded && (
      <div className="flex flex-wrap border-b border-gray-100 dark:border-white/5">
        <button type="button" onClick={() => setMizanTabValue(0)} className={tabClass(mizanTabValue === 0)}>
          <FileSpreadsheet size={16} />
          {t('edefter.tabTrialBalanceData')}
        </button>
        {(hasAgac || agacPending) && (
          <button type="button" onClick={() => setMizanTabValue(1)} className={tabClass(mizanTabValue === 1)}>
            <BookOpen size={16} />
            {t('edefter.tabAdjustedTrialBalance')}
          </button>
        )}
        {hasYevmiye && (
          <button type="button" onClick={() => setMizanTabValue(2)} className={tabClass(mizanTabValue === 2)}>
            <BookOpen size={16} />
            {t('edefter.tabJournalTransferCleaning')}
          </button>
        )}
        {hasGroupedMizan && (
          <button type="button" onClick={() => setMizanTabValue(3)} className={tabClass(mizanTabValue === 3)}>
            <Scale size={16} />
            {t('edefter.tabBalanceSheet')}
          </button>
        )}
        {hasGroupedMizan && (
          <button type="button" onClick={() => setMizanTabValue(4)} className={tabClass(mizanTabValue === 4)}>
            <BookOpen size={16} />
            {t('edefter.tabRelatedParties')}
          </button>
        )}
      </div>
    )}
  </div>
);

export default MizanEmbeddedPreviewChrome;
